import { environment } from 'src/environments/environment';

export const LOCAL_STORAGE = {
    TOKEN: `${ environment.sessionKey }`,
    USER: `${ environment.sessionKey }User`
};